import { JsonService } from '../../@core/services/json.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bottom-bar',
  templateUrl: './bottom-bar.component.html',
  styleUrls: ['./bottom-bar.component.scss']
})
export class BottomBarComponent implements OnInit {

  links:any;
  //temp;
  constructor(private jsonService:JsonService) {
    this.jsonService.getLinks().subscribe((res)=>{
      this.links = res;
    });
   } 

  ngOnInit(): void {
    //this.links = this.jsonService.getLinks();
    
    //console.log(this.temp.links);
    //this.links.uls = this.jsonService.getLinks().links;
    //this.links.socialLinks = this.jsonService.getLinks().socialLinks;
    //this.links.terms = this.jsonService.getLinks().termsLink;
    //console.log(this.links.uls);
  }

}
